import { styled } from '@mui/material/styles';
import type { GridRenderCellParams } from '@mui/x-data-grid';
import { Citation } from '@trinity/chat-components/components/Markdown/Citations';
import { ChatMarkdown } from '../Markdown/Markdown';
import { TableActionsContainer } from './Table.RowContainer';

export const TableCell = (params: GridRenderCellParams) => {
  const cellValue = String(params.value || '');

  // Handle citation cells
  if (/\^\d+[a-z]*\^/.test(cellValue)) {
    const value = cellValue.replace(/^\^([^^]+)\^$/, '$1');
    return (
      <Citation
        style={{ maxHeight: 18, minWidth: 12, minHeight: 18 }}
        value={value}
      />
    );
  }

  // Handle markdown cells with arrowButton
  // TODO: improve support for markdown in table cells
  if (cellValue.includes('arrowButton')) {
    return (
      <TableActionsContainer row={params.row}>
        <StyledCell>
          <ChatMarkdown value={cellValue} />
        </StyledCell>
      </TableActionsContainer>
    );
  }

  // Handle regular cells
  return cellValue;
};

const StyledCell = styled('div')({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
});
